import { exports as nonIterableRestExports, __module as nonIterableRest } from '../../../../_virtual/nonIterableRest.js';

var hasRequiredNonIterableRest;

function requireNonIterableRest () {
	if (hasRequiredNonIterableRest) return nonIterableRestExports;
	hasRequiredNonIterableRest = 1;
	(function (module) {
		function _nonIterableRest() {
		  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
		}
		module.exports = _nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;
} (nonIterableRest));
	return nonIterableRestExports;
}

export { requireNonIterableRest as __require };
//# sourceMappingURL=nonIterableRest.js.map
